export default __webpack_public_path__ + "static/media/Large Gas Grenade.c6ce9df2.PNG";